import { Container, DisplayObject } from "pixi.js";

export class HBox extends Container {

    public get elementsSpacing(): number {
        return this.spacing;
    }

    public set elementsSpacing(value: number) {
        this.spacing = value;
        this.alignmentStrategy();
    }

    public constructor(
        private spacing: number = 0
    ) {
        super();
    }

    public override addChild<U extends DisplayObject[]>(...children: U): U[0] {
        for (const child of children) {
            super.addChild(child);
        }
        this.alignmentStrategy();
        return children[0];
    }

    private alignmentStrategy(): void {
        let x = 0;
        for (const child of this.children) {
            if (child instanceof Container) {
                child.position.x = x;
                x += this.getElementWidth(child) + this.spacing;
            }
        }
    }

    private getElementWidth(element: DisplayObject): number {
        if (!element.visible || !("width" in element)) {
            return 0;
        }
        return element.width as number;
    }
}
